<template>
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="cursor-pointer"
  >
    <rect width="50" height="50" rx="25" fill="#4F4F51" fill-opacity="0.15" />
    <rect
      x="20.0498"
      y="19.6406"
      width="16"
      height="2.00001"
      transform="rotate(45 20.0498 19.6406)"
      fill="black"
    />
    <rect
      x="18.6401"
      y="30.9531"
      width="16"
      height="2.00001"
      transform="rotate(-45 18.6401 30.9531)"
      fill="black"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>